/**
 * Rendert die Merkliste-Seite: liest die gespeicherten Produkt-Handles aus
 * dem localStorage (siehe wishlist.js) und laedt die Produktdaten fuer jedes
 * Handle client-seitig ueber Shopifys eigene Produkt-AJAX-API
 * (/products/{handle}.js) - kein eigener Server noetig.
 */
(function () {
  var ICON_HEART_EMPTY =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="wishlist-icon wishlist-icon--outline"><path fill-rule="evenodd" fill="currentColor" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/></svg>';
  var ICON_HEART_FILLED =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="wishlist-icon wishlist-icon--filled"><path fill="currentColor" d="M10 17.495 2.305 9.901a4.293 4.293 0 0 1 0-6.128 4.433 4.433 0 0 1 6.21 0L10 5.24l1.485-1.467a4.433 4.433 0 0 1 6.21 0 4.293 4.293 0 0 1 0 6.128L10 17.495z"/></svg>';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: currency });
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function productCardHTML(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var imageUrl = image ? image : null;
    var price = formatMoney(product.price);
    var compareAt =
      product.compare_at_price && product.compare_at_price > product.price
        ? formatMoney(product.compare_at_price)
        : null;

    /*
     * Bildverhaeltnis "An Bild anpassen" (wie im Kollektionen-Grid, siehe
     * sections/main-collection-product-grid.liquid -> image_ratio: "adapt"
     * und snippets/card-product.liquid): die Karten-Box bekommt exakt das
     * Seitenverhaeltnis des Bildes selbst (--ratio-percent = 1 / ratio * 100),
     * statt fest auf ein Quadrat (100%) zwingen zu werden. Die Produkt-AJAX-
     * API (/products/{handle}.js) liefert das reale Seitenverhaeltnis ueber
     * product.media[0].aspect_ratio (bzw. width/height als Fallback) - dasselbe
     * Feld, das serverseitig card_product.featured_media.aspect_ratio liefert.
     * Fallback 1 (Quadrat), falls kein Medium/keine Masse vorhanden sind.
     */
    var firstMedia = product.media && product.media[0];
    var ratio = 1;
    if (firstMedia && firstMedia.aspect_ratio) {
      ratio = firstMedia.aspect_ratio;
    } else if (firstMedia && firstMedia.width && firstMedia.height) {
      ratio = firstMedia.width / firstMedia.height;
    }
    if (!ratio || ratio <= 0) {
      ratio = 1;
    }
    var ratioPercent = (100 / ratio).toFixed(2);
    /* Mode Weiss 2026-10-05: einheitliches Kartenformat 1:1,44 (wie card-product "portrait"),
       Bild per object-fit: cover zugeschnitten (component-card.css). */
    ratioPercent = '144.00';

    /*
     * Zweitbild beim Hover (Mode Weiss, 2026-09-06) - identisches Verhalten
     * wie im Kollektionen-Grid (snippets/card-product.liquid,
     * show_secondary_image): Dawns Basis-CSS stapelt zwei <img>-Elemente
     * absolut uebereinander in .media (siehe .media > *:not(.zoom)... in
     * assets/base.css) und blendet ueber die Klasse "media--hover-effect"
     * beim Hover auf .card-wrapper von Bild 1 auf Bild 2 um (siehe
     * .card-wrapper:hover .media.media--hover-effect>img+img in
     * assets/component-card.css) - keine eigene CSS-Regel noetig, nur exakt
     * dieselbe Klasse/Markup-Struktur wie im Grid. Nur echte Bild-Medien
     * (kein Video) werden als Zweitbild verwendet, Video-Medien haben in der
     * Produkt-AJAX-API kein "src"-Feld auf oberster Ebene.
     */
    var secondMedia = product.media && product.media[1];
    var hasSecondImage = !!(secondMedia && secondMedia.media_type === 'image' && secondMedia.src);

    return (
      '<li class="grid__item wishlist-grid__item" data-wishlist-item="' +
      product.handle +
      '">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media">' +
      '<div class="card__inner ratio" style="--ratio-percent: ' +
      ratioPercent +
      '%;">' +
      '<div class="card__media">' +
      '<div class="media media--transparent media--hover-effect">' +
      (imageUrl
        ? '<img src="' +
          imageUrl +
          '&width=533" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="' +
          (firstMedia && firstMedia.width ? firstMedia.width : 533) +
          '" height="' +
          (firstMedia && firstMedia.height ? firstMedia.height : 533) +
          '">'
        : '') +
      (hasSecondImage
        ? '<img src="' +
          secondMedia.src +
          '&width=533" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="' +
          (secondMedia.width || 533) +
          '" height="' +
          (secondMedia.height || 533) +
          '">'
        : '') +
      '</div>' +
      '<button type="button" class="wishlist-button is-active" data-wishlist-toggle data-product-handle="' +
      product.handle +
      '" aria-pressed="true" data-label-add="Zur Merkliste hinzufügen" data-label-remove="Von der Merkliste entfernen" aria-label="Von der Merkliste entfernen">' +
      '<span class="wishlist-button__icon wishlist-button__icon--empty svg-wrapper">' +
      ICON_HEART_EMPTY +
      '</span>' +
      '<span class="wishlist-button__icon wishlist-button__icon--filled svg-wrapper">' +
      ICON_HEART_FILLED +
      '</span>' +
      '</button>' +
      '</div>' +
      '</div>' +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h5"><a href="/products/' +
      product.handle +
      '" class="full-unstyled-link">' +
      escapeHtml(product.title) +
      '</a></h3>' +
      '<div class="price"><div class="price__container">' +
      (compareAt
        ? '<div class="price__sale"><span class="price-item price-item--regular"><s>' +
          compareAt +
          '</s></span><span class="price-item price-item--sale">' +
          price +
          '</span></div>'
        : '<div class="price__regular"><span class="price-item price-item--regular">' + price + '</span></div>') +
      '</div></div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  /*
   * Sanftes Ausblenden entfernter Karten (Mode Weiss, 2026-09-06).
   * Statt bei jedem Klick auf das Herz-Symbol die komplette Merkliste neu vom
   * Server zu laden (bisheriges Verhalten: "wishlist:updated" loeste immer ein
   * volles Promise.all(fetch(...)) fuer ALLE verbleibenden Produkte aus), wird
   * beim reinen Entfernen einer Karte NUR diese eine Karte per CSS-Transition
   * (Opacity + leichtes Skalieren, siehe .wishlist-grid__item--removing in
   * wishlist.css) ausgeblendet und danach aus dem DOM entfernt - kein erneuter
   * Netzwerk-Request noetig. Das ist zugleich die "ressourcenschonende"
   * Umsetzung: nur zwei guenstige, GPU-beschleunigte CSS-Eigenschaften werden
   * animiert, kein JavaScript-Animationsloop. Respektiert ausserdem
   * prefers-reduced-motion (sofortiges Entfernen ohne Uebergang).
   */
  function animateRemoval(items, grid, empty) {
    var reduceMotion = prefersReducedMotion();
    var remaining = items.length;

    function afterAllRemoved() {
      if (grid.querySelectorAll('[data-wishlist-item]').length === 0) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    }

    items.forEach(function (li) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (li.parentNode) li.parentNode.removeChild(li);
        remaining -= 1;
        if (remaining === 0) afterAllRemoved();
      }

      if (reduceMotion) {
        finish();
        return;
      }

      li.classList.add('wishlist-grid__item--removing');
      li.addEventListener('transitionend', finish, { once: true });
      // Absicherung, falls transitionend aus irgendeinem Grund nicht feuert
      // (z. B. Tab im Hintergrund gedrosselt) - Karte verschwindet trotzdem.
      window.setTimeout(finish, 400);
    });
  }

  function fetchAndRenderAll(grid, empty, loading, handles) {
    loading.hidden = false;
    empty.hidden = true;
    grid.hidden = true;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var validProducts = products.filter(Boolean);
      loading.hidden = true;

      if (validProducts.length === 0) {
        empty.hidden = false;
        grid.hidden = true;
        grid.innerHTML = '';
        return;
      }

      grid.innerHTML = validProducts.map(productCardHTML).join('');
      grid.hidden = false;
      if (window.ModeWeissWishlist) {
        window.ModeWeissWishlist.refresh();
      }
    });
  }

  function render() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var loading = document.getElementById('wishlist-loading');
    if (!grid) return;

    var handles = window.ModeWeissWishlist ? window.ModeWeissWishlist.get() : [];

    if (handles.length === 0) {
      loading.hidden = true;
      grid.hidden = true;
      empty.hidden = false;
      grid.innerHTML = '';
      grid.dataset.rendered = '1';
      return;
    }

    var currentItems = Array.prototype.slice.call(grid.querySelectorAll('[data-wishlist-item]'));

    if (grid.dataset.rendered) {
      var currentHandles = currentItems.map(function (li) {
        return li.getAttribute('data-wishlist-item');
      });
      var removedItems = currentItems.filter(function (li) {
        return handles.indexOf(li.getAttribute('data-wishlist-item')) === -1;
      });
      var hasNewHandles = handles.some(function (handle) {
        return currentHandles.indexOf(handle) === -1;
      });

      // Reiner Entfernen-Fall (der Normalfall: Klick auf das Herz auf dieser
      // Seite) -> nur animiert ausblenden, kein Neuladen der uebrigen Karten.
      if (removedItems.length && !hasNewHandles) {
        animateRemoval(removedItems, grid, empty);
        return;
      }
    }

    grid.dataset.rendered = '1';
    fetchAndRenderAll(grid, empty, loading, handles);
  }

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('wishlist:updated', render);
})();
